class LocalStorageService {
  // ls = window.localStorage

  setItem(key, value) {
    value = JSON.stringify(value);
    localStorage.setItem(key, value);
    return true;
  }

  getItem(key) {
    let value = localStorage.getItem(key);
    try {
      return JSON.parse(value);
    } catch (e) {
      return null;
    }
  }

}

export default new LocalStorageService();
